/**
 * Converts a 24-hour ("military") time string (e.g. `"14:05"`) into a 12-hour
 * clock string with an AM/PM suffix (e.g. `"2:05 PM"`).
 *
 * If the value already contains an `AM`/`PM` marker it is returned unchanged,
 * so the function is safe to call more than once on the same value.
 *
 * Shared by the IQ device-observation tables (QoE and UNM).
 */
export function to12HourTime(militaryTime: string): string {
  if (militaryTime.includes('AM') || militaryTime.includes('PM')) {
    return militaryTime;
  }

  const [hoursRaw, minutesRaw] = militaryTime.split(':');
  const hours = Number(hoursRaw);
  const minutes = Number(minutesRaw);
  const period = hours >= 12 ? 'PM' : 'AM';
  const normalizedHours = hours % 12 || 12;

  return `${normalizedHours}:${minutes.toString().padStart(2, '0')} ${period}`;
}
